module.exports = __webpack_public_path__ + "img/REGISTRO 5.1.494c8763.png";